import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.SyncBudgetButton', {
    syncNow: 'Sync now',
    syncBudgetsWith: 'Sync budgets with {integrationName}',
});
